import { DomSanitizer } from "@angular/platform-browser";
import { Block } from "./model/block.model";

export function get2025EarthDayW3(sanitizer: DomSanitizer): Block[] {
    return [
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day15.jpg",
            blockImgName: "",
            blockIndex: 1,
            blockName: "block2",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day16-2.jpg",
            blockImgName: "",
            blockIndex: 1,
            blockName: "block2",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day17.jpg",
            blockImgName: "",
            blockIndex: 1,
            blockName: "block2",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day18.jpg",
            blockImgName: "",
            blockIndex: 1,
            blockName: "block2",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day19.jpg",
            blockImgName: "",
            blockIndex: 1,
            blockName: "block2",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day20.jpg",
            blockImgName: "",
            blockIndex: 1,
            blockName: "block2",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/blog_details/2025EarthDay/day21.jpg",
            blockImgName: "",
            blockIndex: 1,
            blockName: "block2",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
    ];
}
